// extracted by mini-css-extract-plugin
export default {"user-select":"UserIcon_user-select__A8Cn8"};